import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './../pages/lobby/lobby.css';

const FeedbackForm = ({ show, onClose }) => {

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      style={{ zIndex: 1050 }}
      className='feedback-modal-main'
    >
      <Modal.Header closeButton className='feedback-modal'>
        <Modal.Title><span>&#x1F4AC; Feedback</span></Modal.Title>
      </Modal.Header>
      <Modal.Body className='feedback-modal'>
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf_AqHxm2lqcWQrpfF20etXwFO5vyTBwwLh1UM_luKpGWLvPw/viewform?embedded=true" width="640" height="657" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </Modal.Body>
      <Modal.Footer className='feedback-modal'>
        <Button variant="secondary" size='md' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FeedbackForm;